import * as moment from 'moment';
import {IDischargeModel} from '../api/api.types';
import {IMomentFormatter} from '../utils/moment.formatter';

export interface IModelFormatter {
  (dischargeModel:IDischargeModel):string;
}

const modelFormatterFactory = ($filter:ng.IFilterService):IModelFormatter => {
  const momentFormatter = $filter<IMomentFormatter>('momentFormatter');
  return (dischargeModel:IDischargeModel) => {
    if (dischargeModel) {
    	if (dischargeModel.validFrom) {
    		return `${dischargeModel.modelName} -
    		${momentFormatter(moment.unix(dischargeModel.validFrom))}`;
    	} else {
    		return `${dischargeModel.modelName} - ∞`;
    	}
    }
    return '';
  }
};
modelFormatterFactory.$inject = ['$filter'];

export default modelFormatterFactory;



/** WEBPACK FOOTER **
 ** ./app/discharge/model.formatter.ts
 **/